angular.module('ui.help',
    [])

    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('client.help', {
            url: '/help',
            template: customTemplateResolverProvider.get('help.html', 'app/ui/help/help.html'),
            controller: 'HelpController',

            data: {pageTitle: 'OrderManager: Help'}
        });
    })

    .controller('HelpController', function HelpController($scope, $state) {

            $scope.close = function () {
                $state.go('client.home'); // redirect back to home
            };

        }
    );
